import balkanbet from './balkanbet';
import pionir from './pionir';
import stanleybet from './stanleybet';

export default {
  balkanbet,
  pionir,
  stanleybet,
};
